import styled from "styled-components";

const Row = styled.div`
  justify-content: space-between;
  align-items: center;

  @media (max-width: 991px) {
    flex-wrap: wrap;
    align-items: flex-start;
  }
`;

export default Row;
